import { Dialog } from 'primereact/dialog';
import classes from './marketStrategyHistoryModal.module.scss';
import { observer } from 'mobx-react';
import { Dropdown } from 'primereact/dropdown';
import { useMarketStrategyHistoryModal } from './useMarketStrategyHistoryModal';
import { Skeleton } from 'primereact/skeleton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import deleteIcon from 'assets/icons/deleteIcon.svg';
import { getRoundedValueForMarketShare } from 'utils/computation';

const MarketStrategyHistoryModal = ({
  visibility,
  toggleVisibility,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
}) => {
  const {
    selectedCOT,
    setSelectedCOT,
    dropdownRef,
    hiddenInputElementRef,
    cotOptions,
    isMarketHistoryLoading,
    marketStrategyHistoricalData,
    columnDetails,
    handleDeleteFutureTms,
    checkIfCurrentRowIsBeingDelete,
  } = useMarketStrategyHistoryModal();

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      header="Market Strategy Historical Values"
      headerClassName={classes.modalHeader}
      visible={visibility}
      style={{ width: '40vw' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      <div className={classes.modalContainer}>
        <div className={classes.dropdownWrapperDiv}>
          <label htmlFor="username">COT</label>
          {cotOptions().length > 0 && (
            <Dropdown
              disabled={isMarketHistoryLoading}
              focusInputRef={dropdownRef}
              onFocus={() => {
                if (dropdownRef) dropdownRef.current?.focus();
              }}
              value={selectedCOT}
              onChange={e => {
                setSelectedCOT(e.value);
              }}
              options={cotOptions()}
              optionLabel="name"
              placeholder="Select strategy"
            />
          )}
          <input ref={hiddenInputElementRef} style={{ visibility: 'hidden' }}></input>
        </div>
        {isMarketHistoryLoading ? (
          <Skeleton height="10rem" style={{ width: '100%' }} />
        ) : (
          <div className={classes.tablesContainer}>
            <div className={classes.tablesContainerInstance}>
              <div className={classes.tableHeading}>Future TMS</div>
              <table className={classes.datatable}>
                <thead>
                  <tr>
                    {columnDetails.map((column, index) => {
                      return <th key={index}>{column.label}</th>;
                    })}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {marketStrategyHistoricalData.future_tms_values.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td>{getRoundedValueForMarketShare(row.TargetMarketShare)}</td>
                        <td>{row.TMSStrategyID.TMSStrategyCode}</td>
                        <td>{row.StartDate} </td>
                        <td>{row.EndDate}</td>
                        <td>
                          {!checkIfCurrentRowIsBeingDelete(row.MarketShareID as number) ? (
                            <Button
                              onClick={() => handleDeleteFutureTms(row.MarketShareID as number)}
                              className={classes.deleteIconButton}
                              icon={<img src={deleteIcon} alt="delete" />}
                              rounded
                              text
                              aria-label="delete"
                            />
                          ) : (
                            <ProgressSpinner
                              style={{ width: '25px', height: '25px' }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={classes.tablesContainerInstance}>
              <div className={classes.tableHeading}>Past TMS</div>
              <table className={classes.datatable}>
                <thead>
                  <tr>
                    {columnDetails.map((column, index) => {
                      return <th key={index}>{column.label}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {marketStrategyHistoricalData.past_tms_values.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td>{parseFloat(row.TargetMarketShare) * 100}</td>
                        <td>{row.TMSStrategyID.TMSStrategyCode}</td>
                        <td>{row.StartDate} </td>
                        <td>{row.EndDate}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default observer(MarketStrategyHistoryModal);
